export class Step {
   order: number;

   name: string;

   instructions: string;
}
